import { render } from "./LbrxButton.vue?vue&type=template&id=5d650692&scoped=true"
import script from "./LbrxButton.vue?vue&type=script&lang=js"
export * from "./LbrxButton.vue?vue&type=script&lang=js"

import "./LbrxButton.vue?vue&type=style&index=0&id=5d650692&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d650692"]])

export default __exports__